import { Single } from "../../base/single/single";

export declare class SingleSelectInsertList extends Single {
    static xtype: string;
    static EVENT_CHANGE: string;
}
